import type { TranslationKeys } from './types';

export const DEFAULT_TRANSLATIONS = {
  _0P: '{0} P',
  congratulations: 'Congratulations!',
  youHaveLoyaltyPointsThatYouCanUseOnThisProduct:
    'You have loyalty points that you can use on this product.',
  chooseHowYouWantToPayForIt: 'Choose how you want to pay for it:',
  loyaltyPrice: ' + {0}',
};

export const DEFAULT_CONFIG = {
  staticApiUrl: '',
  tenant: '',
  translations: DEFAULT_TRANSLATIONS,
};

/**
 * Use this object to access the particular translaion ID / key.
 */
export const translationKeys = Object.fromEntries(
  Object.keys(DEFAULT_TRANSLATIONS).map((cur) => [cur, cur]),
) as TranslationKeys;
